import { compact, defaults, identity } from 'lodash';

import { Quote } from '@lockton-apps/shared/interfaces';

import { quoteActions } from '../constants/registry/quotes-table.constant';
import {
  DynamicTableBreakpoints,
  DynamicTableColumnTypes,
  DynamicTableConfig,
} from '../interfaces/dynamic-table.interface';

const lsosQuotesTablePreset: Partial<DynamicTableConfig> = {
  columns: [
    { id: 'title' },
    { id: 'assignedBroker' },
    { id: 'workflowStatus' },
    {
      id: 'claims',
      label: $localize`Claims`,
      type: DynamicTableColumnTypes.Template,
      columnType: 'claims',
      sortable: true,
      props: {
        path: 'additionalFields.hasClaims',
        predicate: (hasClaims: 'true' | 'false' | undefined) =>
          hasClaims === 'true',
      },
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: 1,
          order: 3,
        },
        [DynamicTableBreakpoints.SM]: {
          order: 2,
        },
      },
    },
    { id: 'lastActivity' },
    {
      id: 'contextMenu',
      props: {
        actions: [
          quoteActions['viewClient'],
          quoteActions['viewStatus'],
          quoteActions['assignToBroker'],
          quoteActions['viewProposal'],
        ],
      },
    },
  ],
};

const lsosClientEnquiriesQuotesTablePreset: Partial<DynamicTableConfig> = {
  columns: compact([
    { id: 'title' },
    {
      id: 'assignedBroker',
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: '0 0 50%',
          order: 3,
        },
        [DynamicTableBreakpoints.SM]: {
          flex: 2,
          order: 2,
        },
      },
    },
    {
      id: 'assignedContacts',
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: '0 0 50%',
          order: 3,
        },
        [DynamicTableBreakpoints.SM]: {
          flex: 2,
          order: 2,
        },
      },
    },
    {
      id: 'workflowStatus',
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: '0 0 50%',
          order: 4,
        },
        [DynamicTableBreakpoints.SM]: {
          flex: 1,
          order: 3,
        },
      },
    },
    {
      id: 'claims',
      label: $localize`Claims`,
      type: DynamicTableColumnTypes.Template,
      columnType: 'claims',
      props: {
        path: 'proposal.formData.data.claims.claims.notReportedClaims',
        predicate: identity,
      },
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: '0 0 50%',
          order: 5,
        },
        [DynamicTableBreakpoints.SM]: {
          flex: 1,
          order: 4,
        },
      },
    },
    {
      id: 'lastActivity',
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: '0 0 50%',
          order: 6,
        },
        [DynamicTableBreakpoints.SM]: {
          flex: 1,
          order: 5,
        },
      },
    },
    {
      id: 'contextMenu',
      props: {
        actions: compact([
          quoteActions['viewStatus'],
          quoteActions['assignToBroker'],
          quoteActions['assignContact'],
          quoteActions['viewProposal'],
          defaults(
            {
              hidden: (quote: Quote) => !!quote.propFormId,
            },
            quoteActions['editEnquiry']
          ),
        ]),
      },
    },
  ]),
};

export { lsosQuotesTablePreset, lsosClientEnquiriesQuotesTablePreset };
